/* [HZ-DIL] Ekran okuyucu metinleri dil köküne göre kurulur.
   Bu bir .js varlığı olduğu için Liquid'in `| t` filtresi burada çalışmaz;
   dil, theme.liquid'in <html lang="..."> değerinden okunur. Türkçe dışındaki
   her dil İngilizce metni alır. Metinler locales/*.json içindeki
   hz.plp.* anahtarlarıyla birebir aynı tutulmuştur. */
var HZD = (function () {
  var tr = (document.documentElement.getAttribute('lang') || 'tr')
             .toLowerCase().indexOf('tr') === 0;
  return tr
    ? { favAria: function (n) { return 'Favorilerim — ' + n + ' ürün'; },
        favEkle: ' — favorilere ekle',
        favCikar: ' — favorilerden çıkar',
        baslangic: 'başlangıç',
        bitti: 'tükendi' }
    : { favAria: function (n) { return 'My favourites — ' + n + (n === 1 ? ' item' : ' items'); },
        favEkle: ' — add to favourites',
        favCikar: ' — remove from favourites',
        baslangic: 'from',
        bitti: 'sold out' };
})();

/* HALICIZADE — koleksiyon ve arama sayfası etkileşimleri
   · ölçü seçimi → fiyat, ₺/m², indirim rozeti ve gerçek ölçek
   · +N → gizli ölçüler
   · Bitenler → tükenmiş ölçüler (soluk çipler)
   · gerçek ölçek → en ve boy ayrı ayrı ölçeklenir
   · favoriler → localStorage
   · FİLTRELER → sayfa yenilenmeden, Shopify Section Rendering API ile
*/
(function () {
  'use strict';

  /* ---------- gerçek ölçek ----------
     En ve boy ayrı ayrı ölçeklenir. Ortak katsayı: sayfadaki en uzun kenar. */
  var REF = null;
  function referans() {
    if (REF !== null) return REF;
    var en = 0;
    document.querySelectorAll('.card[data-w0]').forEach(function (c) {
      var w = +c.dataset.w0 || 0, h = +c.dataset.h0 || 0;
      if (w > en) en = w;
      if (h > en) en = h;
    });
    REF = en || 400;
    return REF;
  }
  function kartOlcegiKur(c, w, h, not) {
    w = +w || 0; h = +h || 0;
    if (w > 0 && h > 0) {
      var r = referans();
      c.style.setProperty('--sw', Math.round((w / r) * 1000) / 1000);
      c.style.setProperty('--sh', Math.round((h / r) * 1000) / 1000);
    }
    var n = c.querySelector('.card__scalenote');
    if (n && not) n.textContent = not;
  }
  function olcekleriKur() {
    REF = null;
    document.querySelectorAll('.card[data-w0]').forEach(function (c) {
      kartOlcegiKur(c, c.dataset.w0, c.dataset.h0, null);
    });
  }
  olcekleriKur();

  /* ---------- indirim gösterimi ----------
     Ölçü seçildiğinde o varyantın kendi indirimi yazılır:
       [data-was]      üstü çizili eski fiyat
       [data-off]      "%30 indirim" etiketi
       [data-indrozet] fotoğrafın köşesindeki oran rozeti
     temel = true → seçim kaldırıldı, rozet ürünün Liquid'den gelen
     başlangıç metnine (data-base) döner. */
  function indirimYaz(kart, cp, ind, temel) {
    var was = kart.querySelector('[data-was]');
    var wasVal = kart.querySelector('[data-wasval]');
    var off = kart.querySelector('[data-off]');
    var rz = kart.querySelector('[data-indrozet]');
    var pr = kart.querySelector('.card__price');
    ind = +ind || 0;
    var acik = ind > 0 && !!cp;

    if (was) {
      if (acik) {
        if (wasVal) wasVal.innerHTML = cp;
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }
    if (off) {
      if (acik) {
        var ek = off.dataset.yazi ? ' ' + off.dataset.yazi : '';
        off.textContent = '%' + ind + ek;
        off.hidden = false;
      } else {
        off.hidden = true;
      }
    }
    if (rz) {
      if (temel) {
        var b = rz.dataset.base || '';
        rz.innerHTML = b;
        rz.hidden = b === '';
      } else if (acik) {
        rz.textContent = '%' + ind;
        rz.hidden = false;
      } else {
        rz.hidden = true;
      }
    }
    if (pr) {
      if (acik) pr.classList.add('card__price--ind');
      else pr.classList.remove('card__price--ind');
    }
  }

  /* ---------- favoriler ---------- */
  var ANAHTAR = 'hz-favoriler';
  var favs = [];
  try { favs = JSON.parse(localStorage.getItem(ANAHTAR) || '[]'); } catch (e) { favs = []; }
  function favYaz() {
    try { localStorage.setItem(ANAHTAR, JSON.stringify(favs)); } catch (e) { /* yoksay */ }
  }
  function favSay() {
    var el = document.querySelector('[data-favn]');
    var btn = document.querySelector('[data-favlist]');
    if (el) { el.textContent = favs.length; el.hidden = favs.length === 0; }
    if (btn) {
      btn.classList.toggle('on', favs.length > 0);
      btn.setAttribute('aria-label', HZD.favAria(favs.length));
    }
  }
  function favKur() {
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      var on = favs.indexOf(b.dataset.key) !== -1;
      b.setAttribute('aria-pressed', String(on));
      var ad = (b.getAttribute('aria-label') || '').replace(/ — .*$/, '');
      b.setAttribute('aria-label', ad + (on ? HZD.favCikar : HZD.favEkle));
    });
    favSay();
  }
  favKur();

  /* ---------- telefonda ızgara sütun sayısı ----------
     Varsayılan tek halı. Kullanıcı araç çubuğundan iki sütunu seçerse
     ızgaraya data-kolon="2" yazılır ve seçim tarayıcıda saklanır.
     560px üstünde bu öznitelik CSS'te hiçbir şey yapmaz. */
  var KOL_ANAHTAR = 'hz-kolon';
  var kolon = '1';
  try { if (localStorage.getItem(KOL_ANAHTAR) === '2') kolon = '2'; } catch (e) { kolon = '1'; }
  function kolonKur() {
    var g = document.querySelector('[data-grid]');
    if (g) g.setAttribute('data-kolon', kolon);
    document.querySelectorAll('[data-kolonsec]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-kolonsec') === kolon));
    });
  }
  kolonKur();

  /* ---------- ölçü filtresi çipi — [HZ-OLCU] 6 Ekim 2026 ----------
     Aramada yalnız ölçü yazılınca ("200x300") müşteri tüm halılar
     sayfasına ?filter.v.option.boyut=200 X 300 ile gelir. Boyut filtresi
     metrekare gruplarıyla tanımlı olduğu için Shopify bu tam ölçüyü
     etkin filtre olarak listelemiyor; çip burada adresten kurulur.
     Çipteki bağlantı ölçüyü adresten çıkarır (mevcut çip mantığıyla gider). */
  function olcuCipi() {
    var kap = document.querySelector('[data-chips]');
    if (!kap) return;
    var u;
    try { u = new URL(location.href); } catch (e) { return; }
    var deger = u.searchParams.getAll('filter.v.option.boyut').filter(function (v) {
      return /^\d+\s*X\s*\d+$/i.test(v);
    })[0];
    var eski = kap.querySelector('[data-olcucip]');
    if (eski) eski.remove();
    if (!deger) return;
    var p = deger.split(/\s*X\s*/i);
    var tr = (document.documentElement.getAttribute('lang') || 'tr').toLowerCase().indexOf('tr') === 0;
    u.searchParams.delete('filter.v.option.boyut');
    u.searchParams.delete('page');
    var a = document.createElement('a');
    a.className = 'chip';
    a.setAttribute('data-olcucip', '');
    a.href = u.pathname + u.search;
    a.innerHTML = p[0] + '×' + p[1] + ' cm<span class="x" aria-hidden="true">×</span><span class="vh">' +
      (tr ? 'ölçü filtresini kaldır' : 'remove size filter') + '</span>';
    kap.insertBefore(a, kap.firstChild);
    kap.hidden = false;
  }
  olcuCipi();

  /* ---------- tıklamalar (olay delegasyonu: DOM değişse de çalışır) ---------- */
  document.addEventListener('click', function (e) {
    /* ölçü seçimi */
    var sz = e.target.closest('[data-size]');
    if (sz) {
      e.preventDefault();
      var kart = sz.closest('.card');
      var secili = sz.getAttribute('aria-pressed') === 'true';
      kart.querySelectorAll('[data-size]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      var fiyat = kart.querySelector('[data-price]');
      var birim = kart.querySelector('[data-unit]');
      var etiket = kart.querySelector('[data-from]');
      if (secili) {
        var ilk = kart.querySelector('[data-size]');
        fiyat.innerHTML = ilk.dataset.p;
        if (birim) birim.innerHTML = '≈ ' + ilk.dataset.m2 + '/m²';
        if (etiket) etiket.textContent = HZD.baslangic;
        indirimYaz(kart, ilk.dataset.cp, ilk.dataset.ind, true);
        kartOlcegiKur(kart, kart.dataset.w0, kart.dataset.h0, kart.dataset.note0);
      } else {
        sz.setAttribute('aria-pressed', 'true');
        fiyat.innerHTML = sz.dataset.p;
        if (birim) birim.innerHTML = '≈ ' + sz.dataset.m2 + '/m²';
        /* [HZ-BITTI] tükenmiş ölçü seçildiyse fiyatın yanında "tükendi" yazar */
        if (etiket) etiket.textContent = sz.textContent.trim() + ' cm' +
          (sz.hasAttribute('data-bitti') ? ' · ' + HZD.bitti : '');
        indirimYaz(kart, sz.dataset.cp, sz.dataset.ind, false);
        kartOlcegiKur(kart, sz.dataset.w, sz.dataset.h, sz.textContent.trim() + ' cm');
      }
      return;
    }

    /* tükenmiş ölçüler — [HZ-BITTI] 6 Ekim 2026.
       Düğme yalnız listeyi açıp kapar. Tükenmiş çipler de [data-size]:
       yukarıdaki ölçü seçimiyle aynı yoldan fiyatı gösterirler. */
    var bt = e.target.closest('[data-bitenler]');
    if (bt) {
      e.preventDefault();
      var ulb = bt.closest('.card__sizes');
      var acikb = ulb.hasAttribute('data-bitti-acik');
      if (acikb) ulb.removeAttribute('data-bitti-acik'); else ulb.setAttribute('data-bitti-acik', '');
      bt.setAttribute('aria-expanded', String(!acikb));
      return;
    }

    /* gizli ölçüler */
    var mo = e.target.closest('[data-moresizes]');
    if (mo) {
      e.preventDefault();
      var ul = mo.closest('.card__sizes');
      var acik = ul.hasAttribute('data-expanded');
      if (acik) { ul.removeAttribute('data-expanded'); mo.textContent = '+' + mo.dataset.n; }
      else { ul.setAttribute('data-expanded', ''); mo.textContent = '−'; }
      mo.setAttribute('aria-expanded', String(!acik));
      return;
    }

    /* favori */
    var fv = e.target.closest('[data-fav]');
    if (fv) {
      e.preventDefault();
      var k = fv.dataset.key;
      var i = favs.indexOf(k);
      if (i === -1) favs.push(k); else favs.splice(i, 1);
      favYaz(); favKur();
      return;
    }

    /* telefonda sütun sayısı — [data-scale]'den ÖNCE gelmeli */
    var kb = e.target.closest('[data-kolonsec]');
    if (kb) {
      e.preventDefault();
      kolon = kb.getAttribute('data-kolonsec') === '2' ? '2' : '1';
      try { localStorage.setItem(KOL_ANAHTAR, kolon); } catch (err) { /* yoksay */ }
      kolonKur();
      return;
    }

    /* gerçek ölçek */
    var sc = e.target.closest('[data-scale]');
    if (sc) {
      var grid = document.querySelector('[data-grid]');
      if (grid) grid.setAttribute('data-scale', sc.getAttribute('data-scale'));
      document.querySelectorAll('[data-scale]').forEach(function (b) {
        if (b.closest('.scaletog')) b.setAttribute('aria-pressed', String(b === sc));
      });
      return;
    }

    /* mobil filtre çekmecesi */
    var fb = e.target.closest('[data-filtre-ac]');
    if (fb) {
      var side = document.querySelector('[data-side]');
      if (!side) return;
      var on = side.hasAttribute('data-on');
      if (on) side.removeAttribute('data-on'); else side.setAttribute('data-on', '');
      fb.setAttribute('aria-expanded', String(!on));
      if (!on) side.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }

    /* filtre çipini kaldır / temizle — bunlar <a>, araya giriyoruz */
    var cip = e.target.closest('.chips a, .side__clear, .bos .btn');
    if (cip && cip.getAttribute('href')) {
      var hedef = cip.getAttribute('href');
      /* yalnız aynı sayfada kalan bağlantılar bölüm yenilemesiyle gider;
         başka sayfaya çıkanlar (ör. arama boşken "Koleksiyonlara göz at")
         normal bağlantı gibi davranır */
      var ayniSayfa = hedef.split('?')[0].replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
      if (bolum() && ayniSayfa) { e.preventDefault(); git(hedef); }
    }
  });

  /* ================= FİLTRELER: sayfa yenilenmeden =================
     Shopify Section Rendering API: aynı adrese "&section_id=..." eklenince
     yalnız o bölümün HTML'i döner. Izgarayı ve filtre sayaçlarını onunla
     değiştiriyoruz; sayfa yeniden yüklenmiyor, kaydırma yeri korunuyor.
     Aynı mekanizma koleksiyon (hz-collection) ve arama (hz-search)
     bölümlerinde çalışır — ikisi de .hz-plp-grid sınıfını taşır. */

  var bolumEl = document.querySelector('[id^="shopify-section"].hz-plp-grid')
             || document.querySelector('[id^="shopify-section"] .layout') && document.querySelector('[id^="shopify-section"].hz-plp-grid');
  function bolum() {
    if (!bolumEl) bolumEl = document.querySelector('[id^="shopify-section"].hz-plp-grid');
    return bolumEl;
  }
  var bolumId = bolum() ? bolum().id.replace(/^shopify-section-/, '') : null;
  var destek = !!(bolumId && window.fetch && window.DOMParser && window.history && history.pushState);

  var istek = null, zamanlayici = null;

  function yukleniyor(durum) {
    var g = bolum() && bolum().querySelector('.layout');
    if (!g) return;
    g.style.transition = 'opacity .18s ease';
    g.style.opacity = durum ? '.45' : '';
    g.style.pointerEvents = durum ? 'none' : '';
  }

  /* değiştirmeden önce korunacak durumlar */
  function durumAl() {
    var s = { acik: [], drawer: false, olcek: null, odak: null };
    bolum().querySelectorAll('details.facet').forEach(function (d, i) { if (d.open) s.acik.push(i); });
    var side = bolum().querySelector('[data-side]');
    s.drawer = !!(side && side.hasAttribute('data-on'));
    var grid = bolum().querySelector('[data-grid]');
    s.olcek = grid ? grid.getAttribute('data-scale') : null;
    var a = document.activeElement;
    if (a && a.name) s.odak = { name: a.name, value: a.value };
    return s;
  }
  function durumUygula(s) {
    var detaylar = bolum().querySelectorAll('details.facet');
    detaylar.forEach(function (d, i) { d.open = s.acik.indexOf(i) !== -1; });
    var side = bolum().querySelector('[data-side]');
    if (side && s.drawer) side.setAttribute('data-on', '');
    var grid = bolum().querySelector('[data-grid]');
    if (grid && s.olcek) {
      grid.setAttribute('data-scale', s.olcek);
      document.querySelectorAll('.scaletog button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-scale') === s.olcek));
      });
    }
    if (s.odak) {
      var el = bolum().querySelector('[name="' + CSS.escape(s.odak.name) + '"][value="' + CSS.escape(s.odak.value) + '"]')
            || bolum().querySelector('[name="' + CSS.escape(s.odak.name) + '"]');
      if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }
    olcekleriKur();
    favKur();
    kolonKur();
    olcuCipi();
  }

  function git(adres, gecmise) {
    if (!destek) { location.href = adres; return; }
    if (istek) istek.abort();
    istek = new AbortController();
    var durum = durumAl();
    yukleniyor(true);

    var ayrac = adres.indexOf('?') === -1 ? '?' : '&';
    fetch(adres + ayrac + 'section_id=' + encodeURIComponent(bolumId), { signal: istek.signal })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var yeni = new DOMParser().parseFromString(html, 'text/html');
        var kaynak = yeni.querySelector('[id^="shopify-section"]') || yeni.body;
        bolum().innerHTML = kaynak.innerHTML;
        if (gecmise !== false) history.pushState({ hz: 1 }, '', adres);
        durumUygula(durum);
        yukleniyor(false);
        istek = null;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;   /* yeni seçim geldi, sorun değil */
        location.href = adres;                          /* her ihtimale karşı klasik yol */
      });
  }

  function formdanAdres(form) {
    var fd = new FormData(form);
    var p = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    var q = p.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }

  var form = document.querySelector('[data-filtre]');
  document.addEventListener('change', function (e) {
    var f = e.target.closest('[data-filtre]');
    if (f) {
      if (!destek) { f.submit(); return; }
      clearTimeout(zamanlayici);
      /* kutucuklarda kısa bekleme: üst üste tıklarsan tek istek olur */
      zamanlayici = setTimeout(function () { git(formdanAdres(f)); }, 260);
      return;
    }
    var s = e.target.closest('[data-sirala]');
    if (s) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      git(u.pathname + u.search);
    }
  });

  /* fiyat kutuları: yazarken değil, yazmayı bırakınca */
  document.addEventListener('input', function (e) {
    var f = e.target.closest('[data-filtre]');
    if (!f || e.target.type !== 'number') return;
    if (!destek) return;
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(function () { git(formdanAdres(f)); }, 700);
  });

  /* sayfalama bağlantıları da yenilenmeden */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.pager a, .more a');
    if (!a || !destek) return;
    e.preventDefault();
    git(a.getAttribute('href'));
    var ust = bolum().querySelector('.bar');
    if (ust) ust.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });

  /* geri/ileri tuşu */
  window.addEventListener('popstate', function () {
    if (destek) git(location.pathname + location.search, false);
  });

  /* JS kapalıysa noscript butonu zaten var; form.submit() yedeği duruyor */
  if (!destek && form) {
    form.addEventListener('change', function () { form.submit(); });
  }
})();